import { LOCAL_VAR } from './../../../core/constants';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { STATES } from '@app/core/constants';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GroupsService } from '@app/core/service/groups.service';
import { finalize } from 'rxjs/operators';
import { DealsService } from '@app/core/service/deals.service';

@Component({
  selector: 'app-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss']
})
export class CreateGroupComponent implements OnInit {
  @Input()
  dealId? = '';

  @Input()
  groupName:any;

  groupCreateForm: FormGroup;
  isLoading = false;
  queryParams: any;
  states: any = STATES;
  selectedAgent: any = null;
  dealerLocation: FormArray;
  zipSpin=0;
  spinZip:any={};
  dealData: any;
  groupData: any;
  editGroupId='';

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private dealsService: DealsService,
    private groupsService: GroupsService
  ) {
    this.selectedAgent = localStorage.getItem(LOCAL_VAR.selectedAgent);
    this.selectedAgent = JSON.parse(this.selectedAgent);   
    this.dealData = this.dealsService.dealData;
  }

  ngOnInit() {
    console.log(this.groupName)
     this.route.queryParams.pipe().subscribe(params => {
      this.queryParams = params;
      this.createForm();
    });
  }

  private createForm() {
    let groupName='';
    if (typeof this.groupName === 'object') {
      console.log(typeof this.groupName);
      this.editGroupId = this.groupName._id;
      groupName = this.groupName.name;
    } else if (this.groupName) {
      this.editGroupId = '';
      groupName = this.groupName;
    }
    this.groupCreateForm = this.formBuilder.group({
      name: [groupName?groupName:'', [Validators.required]],
      dealId: [this.dealId?{_id:this.dealId,name:this.dealData.name}:null],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zip: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(5)
        ])
      ],
      phone: [
        '',
        Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      // email: ['', Validators.compose([Validators.required, Validators.pattern(/^(\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
      einNumber: [
        '',
        Validators.compose([
          Validators.minLength(5),
          Validators.maxLength(15)
        ])
      ],
      locations: this.formBuilder.array([])
    });
    this.dealerLocation = this.groupCreateForm.get('locations') as FormArray;
    this.prefillData();
  }

  prefillData() {
    if (this.editGroupId != "") {
      this.isLoading = true;
      this.groupsService
        .getAgentGroupDetail(this.selectedAgent._id, this.editGroupId)
        .pipe()
        .subscribe((response: any) => {
          this.isLoading = false;
          this.groupData = response;
          if (this.groupData) {
            this.groupCreateForm.get('einNumber').setValue(this.groupData.einNumber);
            this.groupCreateForm.get('city').setValue(this.groupData.city);
            this.groupCreateForm.get('state').setValue(this.groupData.state);
            this.groupCreateForm.get('zip').setValue(this.groupData.zip);
            this.groupCreateForm.get('address').setValue(this.groupData.address);
            this.groupCreateForm.get('phone').setValue(this.groupData.phone);
            this.dealerLocation = this.groupCreateForm.get('locations') as FormArray;
            if (this.groupData && this.groupData.locations && this.groupData.locations.length > 0) {
              this.groupData.locations.forEach((child: any, index: any) => {
                this.dealerLocation.push(this.createNewGroup(child));
                // this.dbaCheck(index,child.dbaCheck);
              });
            }
          }
        });
    } else if (this.dealId && this.dealData) {
      this.groupCreateForm.get('zip').setValue(this.dealData.zipCode);
      this.groupCreateForm.get('address').setValue(this.dealData.streetAddress);
      this.groupCreateForm.get('phone').setValue(this.dealData.phoneNumber);
      this.checkZip(this.dealData.zipCode, 'zip');
    }
  }

  checkZip(zipCode: any,key:any) {
    if (zipCode.length == 5 && this.zipSpin!=1) {
      this.zipSpin= 1;
      this.dealsService
      .getZipDetails(zipCode)
      .pipe(
        finalize(() => {
          this.zipSpin= 0;
        })
      )
      .subscribe((rs: any) => {
        if (rs.data) {
          this.groupCreateForm.get('city').setValue(rs.data.city_name);
          this.groupCreateForm.get('state').setValue(rs.data.state_code);
        } else if(key=='zip' && this.dealData) {
          this.groupCreateForm.get('city').setValue(this.dealData.city);
          this.groupCreateForm.get('state').setValue(this.dealData.state);
        } else {
          this.groupCreateForm.get('city').setValue('');
          this.groupCreateForm.get('state').setValue('');
        }
      });
    }
  }

  checkLocationZip(zipCode: any,i:any) {
    if (zipCode.length == 5 && this.spinZip[i]!=1) {
      this.spinZip[i]= 1;
      this.dealsService
      .getZipDetails(zipCode)
      .pipe(
        finalize(() => {
          this.spinZip[i]= 0;
        })
      )
      .subscribe((rs: any) => {
        if (rs.data) {
          this.dealerLocation.controls[i].get('city').setValue(rs.data.city_name);
          this.dealerLocation.controls[i].get('state').setValue(rs.data.state_code);
        } else {
          this.dealerLocation.controls[i].get('city').setValue('');
          this.dealerLocation.controls[i].get('state').setValue('');
        }
      });
    }
  }
  
  createNewGroup(data?: any): FormGroup {
      return this.formBuilder.group({
      id: [
        data && data._id
          ? data._id
          : ''
      ],
      legalName: [
        data && data.legalName
          ? data.legalName
          : '',
        [Validators.required]
      ],
      dba: [
        data && data.dba
          ? data.dba
          : ''
      ],
      dbacheck: [
        data && data.dbacheck
          ? data.dbacheck
          : false
      ],
      einNumber: [
        data && data.einNumber
          ? data.einNumber
          : '',
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(15)
        ])],
      address: [data && data.address
        ? data.address
        : '', [Validators.required]],
      city: [data && data.city
        ? data.city
        : '', [Validators.required]],
      state: [data && data.state
        ? data.state
        : '', [Validators.required]],
      zip: [
        data && data.zip
          ? data.zip
          : '',
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(5)
        ])
      ],
    });
    }
  
    addContact(): void {
      this.dealerLocation = this.groupCreateForm.get('locations') as FormArray;
      this.dealerLocation.push(this.createNewGroup());
    }
  
    removeContact(index: number): void {
      // console.log('Remove ', index);
      this.dealerLocation.removeAt(index);
      // console.log(this.dealerLocation);
      this.groupCreateForm.markAsDirty();
    }
    
    dbaCheck(i: number, check: any) {
      this.dealerLocation.controls[i].get('dbacheck').setValue(check);
      if (check) {
        this.dealerLocation.controls[i].get('dba').setValidators([Validators.required]);
        this.dealerLocation.controls[i].get('dba').updateValueAndValidity();
      } else {
        this.dealerLocation.controls[i].get('dba').setValidators(null);
        this.dealerLocation.controls[i].get('dba').updateValueAndValidity();
      }
    }

  checkValidation() {
    const control = this.groupCreateForm.get('dealId');
    const type = typeof control.value
    if (control && control.value && type !== 'string') {
      control.setErrors(null); // Clear any previous errors
      return true
    } else {
      control.setErrors({ invalidType: true }); // Set a custom error
      return false;
    }
  }

  createGroup() {
    // if (this.checkValidation()) {
    this.isLoading = true;
    if (this.groupData && this.editGroupId) {
      this.groupsService
        .updateAgentGroup(
          this.selectedAgent._id,
          this.editGroupId,
          this.groupCreateForm.value
        )
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe((response: any) => {
          let rplist=[{_id:this.editGroupId,name:this.groupCreateForm.value.name}];
          rplist= rplist.concat(response);
          this.activeModal.close(rplist);
        });
    } else {
      this.groupsService
        .createAgentGroup(this.selectedAgent._id, this.groupCreateForm.value)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe((response: any) => {
          this.activeModal.close(response);
        });
    }
    // }
  }
}
